<template>
  <modal :title="title" size="xs" ref="modal">
    <q-tabs
            v-model="tab"
            dense
            class="text-grey"
            active-color="primary"
            indicator-color="primary"
            align="justify"
            narrow-indicator
    >
      <q-tab name="personal" label="Personal" />
      <q-tab name="file" label="File" />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="personal">
        <div class="q-gutter-md">
          <q-input label="First Name" v-model="client.firstName" outlined />
          <q-input label="Last Name" v-model="client.lastName" outlined />
          <q-input label="Email" type="email" v-model="client.email" outlined />
          <PhoneInput
            label="Phone"
            v-model="client.phone"
            outlined
            required
          />
          <date-picker label="Date of Birth" v-model="client.dateOfBirth" outlined />
        </div>
      </q-tab-panel>
      <q-tab-panel name="file">
        <div class="q-gutter-md">
          <q-input label="File Reference Number" v-model="client.fileRefNo" outlined />
          <date-picker label="Date of Loss" v-model="client.dateOfLoss" outlined />
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <template v-slot:actions>
      <async-btn label="Save" color="primary" :task="task" @click="save" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Client, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import DatePicker from '@/components/form/DatePicker.vue';
import { PhoneInput } from '@/components/form/phone';
import { edit } from './client';

interface Data {
  tab: string,
  task: Promise<void>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    PhoneInput,
    DatePicker,
    Modal,
    AsyncBtn,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  data(): Data {
    return {
      tab: 'personal',
      task: null,
    };
  },
  computed: {
    title(): string {
      return `${this.client.firstName} ${this.client.lastName}`;
    },
  },
  methods: {
    save() {
      this.task = edit(this.client);
      this.task.then(() => {
        this.$emit('ok', this.client);
        (this.$refs.modal as ModalElement).hide();
        notify(`${this.client.firstName} ${this.client.lastName} has been saved.`);
      });
    },
  },
});
</script>
